"use strict";

// Los contactos de una contratista como lista editable. Misma regla que el
// backend (contractor-contacts.js): si el documento ya trae `contacts`, esa es
// la lista; si no, se arma desde los seis campos sueltos de contacto 1 y 2.

const text = value => (typeof value === "string" ? value.trim() : "");

// Como recibe cada contacto los correos de un Envio. Los valores son los del
// backend (contractor-contacts.js, EMAIL_MODES); los textos, lo que ve el
// administrador en el selector.
export const EMAIL_MODE_OPTIONS = [
  { value: "none", text: "No enviar correo", icon: "notifications_off" },
  { value: "to", text: "Correo normal", icon: "mail_outline" },
  { value: "cc", text: "Correo en copia", icon: "content_copy" },
  { value: "bcc", text: "Copia oculta", icon: "visibility_off" }
];

const EMAIL_MODE_VALUES = EMAIL_MODE_OPTIONS.map(o => o.value);

// Misma regla que el backend: un contacto que no trae modo ni bandera vale lo
// que hacia el sistema antes, segun su posicion. El 1 al "para" y con nombre,
// el 2 en copia, el resto sin correo.
export const defaultsForPosition = index => ({
  emailMode: index === 0 ? "to" : index === 1 ? "cc" : "none",
  includeName: index === 0
});

export const emptyContact = (index = 0) =>
  Object.assign({ name: "", phone: "", email: "" }, defaultsForPosition(index));

const normalizeContact = (contact, index) => {
  const mode = contact && contact.emailMode;
  const include = contact && contact.includeName;
  const defaults = defaultsForPosition(index);
  return {
    name: text(contact && contact.name),
    phone: text(contact && contact.phone),
    email: text(contact && contact.email),
    emailMode: EMAIL_MODE_VALUES.indexOf(mode) > -1 ? mode : defaults.emailMode,
    includeName: typeof include === "boolean" ? include : defaults.includeName
  };
};

const isEmpty = contact => !contact.name && !contact.phone && !contact.email;

// Se descartan los vacios ANTES de completar por posicion: un vacio no ocupa
// lugar, igual que en el backend.
const normalizeContacts = list =>
  list.filter(c => !isEmpty(normalizeContact(c, 0))).map(normalizeContact);

export const contactsFrom = doc => {
  if (!doc) return [];
  const stored = normalizeContacts(Array.isArray(doc.contacts) ? doc.contacts : []);
  if (stored.length) return stored;
  return normalizeContacts([
    { name: doc.contactName, phone: doc.contactPhone, email: doc.contactEmail },
    { name: doc.contactName1, phone: doc.contactPhone1, email: doc.contactEmail1 }
  ]);
};
